// Code common to all site pages lives here

/* global jQuery */

const $             = jQuery;   // jQuery loaded via WordPress enqueue process
const dc            = require('./utilities/device-check');
const header        = require('./components/header');
const lity          = require('lity');



/**
 * Check to see if user is on a mobile or tablet device (or not).
 * Set a marker class on the body.
 */
function checkTouch() {
    if (dc.isMobileOrTablet()) {
        $('body').addClass('is-touch');
    } else {
        $('body').addClass('no-touch');
    }
}

function addPageToBodyClass() {
    /* STATIC PAGES ONLY - REMOVE FOR WORDPRESS */
    var pageStub = document.location.href.match(/[^\/]+$/)[0];
    pageStub = pageStub.split('.')[0];
    // console.log('pageStub: '+pageStub);
    if (pageStub == '') {
        pageStub = 'index';
    }
    $('body').addClass(pageStub);
}

function initHeader() {
	// console.log("initHeader()");
    let $header = $('.site-header');
    if ($header.length) {
        header.init($header);
    }
}

function initExpandCollapse() {
    // console.log('initExpandCollapse()');
    // Listen for clicks to expand/collapse content.

    var $myBtn = $('.btn-excol');
    $myBtn.click(function() {
        var $myContent = $(this).next('.excol-content');
        var $notMyButton = $('.btn-excol.open');
        var $notMyContent = $('.excol-content.open');
        // console.log($myContent);
        if ($myContent.is(':hidden')) {
            $(this).toggleClass('open');
            $myContent.toggleClass('open');
            $myContent.slideDown(300);
            $notMyButton.toggleClass('open');
            $notMyContent.toggleClass('open');
            $notMyContent.slideUp(300);
        } else {
            $(this).toggleClass('open');
            $myContent.toggleClass('open');
            $myContent.slideUp(300,function() {
                $myContent.hide();
            });
        }        
    });
}
var pageY;

function initLityNoScroll() {
    // Stop page from scrolling behind lity overlay.
    // NB. There is a slight shift in the page content. Scrollbar width?
    // console.log('initLityNoScroll()');

    var $myLityLinks = $('a[data-lity]');
    var $myCloseLityLinks = $('.close-x[data-lity-close]');
    var bodyTop;

    $myLityLinks.click(function(event) {
        console.log('LITY CLICK');
        event.preventDefault();
        pageY = $(document).scrollTop();
        bodyTop = '-'+pageY+'px';
        console.log('pageY: '+pageY);
        $(document).scrollTop(pageY);
        $('body').attr('style','top:'+bodyTop+'!important; overflow:visible!important;');

        console.log('pageY: '+pageY);
        console.log('bodyTop: '+bodyTop);
        console.log('body CSS top: '+$('body').css('top'));
    })
    $myCloseLityLinks.click(function(event) {
        console.log('LITY CLOSE CLICK');

        console.log('pageY: '+pageY);
        console.log('bodyTop: '+bodyTop);
        console.log('body CSS top: '+$('body').css('top'));

        event.preventDefault();
        $('body').css('top','auto');
        $('body').css('overflow-x','hidden');
        $('body').css('overflow-y','auto');
        $('body').css('top',bodyTop);

        console.log('pageY: '+pageY);
        console.log('bodyTop: '+bodyTop);
        console.log('body CSS top: '+$('body').css('top'));
    })
}

/* AJAX ATC callback */
function initAjaxAtc() {
    // console.log('initAjaxAtc()');
    $('body').on('added_to_cart',function(){
        // Callback -> product added
        // console.log('ATC CALLBACK');

        // OPEN MINI-CART VIA LITY
        $('.lity-content [data-lity-close]').trigger('click');
        lity('#lexrx-mini-cart');

        // console.log('miniCartContent: '+miniCartContent);
        // console.log('#lexrx-mini-cart: '+$('#lexrx-mini-cart')[0].className);
    });    
}

function initFooterSignupTextElements($scopeEl) {
    console.log("initFooterSignupTextElements()");
    
    // Add marker class to any fields that are not empty
    let fieldTypes = 'input[type="text"], input[type="email"], textarea, select';
    let $elements = ($scopeEl !== null) ? $scopeEl.find(fieldTypes) : $(fieldTypes);

    console.dir($elements);

    // Run an initial check...
    $.each($elements, (index, el) => {
        checkForEmpty($(el));
    });
    // Then set up a listener for any changes to the fields
    $elements.on('input propertychange paste', (evt) => {
        checkForEmpty($(evt.target));
    });

    function checkForEmpty($el) {
        // console.log($el.attr('class'));
        // console.log($el.val());
        if (($el.val() !== '') && ($el.val() !== null)) {
            $el.parent().addClass('is-not-empty');
        } else {
            $el.parent().removeClass('is-not-empty');
        }
    }
}

exports.init = function() {
	console.log('COMMON JS');
    // Do common initialization...
    // checkTouch();
    // if (document.location.href.match(/[^\/]+$/)) {
    //     addPageToBodyClass();
    // }
    initHeader();
    initExpandCollapse();
    // initLityNoScroll();
    initAjaxAtc();
    // initBackToTop();
    initFooterSignupTextElements($('.newsletter-form__wrap'));
};
